import { useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { getPlayerRankingEntry } from '../services/ranking.service';
import { RACE_PORTRAITS, raceLabel } from '../utils/raceAssets';
import ProfileAvatar from '../components/ProfileAvatar';
import { Card } from '../components/ui/Card';

export default function PlayerProfilePage() {
    const { userId } = useParams<{ userId: string }>();

    const entryQuery = useQuery({
        queryKey: ['rankings', 'player', userId],
        queryFn: () => getPlayerRankingEntry(userId!),
        enabled: !!userId,
        staleTime: 30_000,
    });

    if (entryQuery.isPending) {
        return (
            <main className="max-w-3xl mx-auto p-4">
                <Card>
                    <p className="text-content-muted">Loading profile…</p>
                </Card>
            </main>
        );
    }

    const entry = entryQuery.data;
    if (!entry) {
        return (
            <main className="max-w-3xl mx-auto p-4">
                <Card>
                    <p className="text-content-muted">Commander not found.</p>
                </Card>
            </main>
        );
    }

    const avatarSrc = entry.photoURL || RACE_PORTRAITS[entry.race];
    const coordinates = entry.mainPlanetCoordinates;

    return (
        <main className="max-w-3xl mx-auto p-4">
            <Card>
                <div className="flex flex-col sm:flex-row items-center sm:items-start gap-6">
                    <ProfileAvatar src={avatarSrc} alt={entry.displayName} racePortrait={!entry.photoURL} />
                    <div className="flex flex-col gap-1 items-center sm:items-start">
                        <h2 className="text-heading text-content-primary">{entry.displayName}</h2>
                        <p className="text-content-secondary text-body">{raceLabel(entry.race)}</p>
                        <p className="text-content-secondary text-body">
                            {coordinates
                                ? `G:${coordinates.galaxy} S:${coordinates.system} P:${coordinates.position}`
                                : 'No planet yet'}
                        </p>
                    </div>
                </div>
            </Card>
        </main>
    );
}
